export function chunkArray(array, chunkSize) {
  const results = []

  for (let i = 0; i < array.length; i += chunkSize) {
    results.push(array.slice(i, i + chunkSize))
  }

  return results
}
